module.exports = __webpack_public_path__ + "templates.image-banner-display-512a8099.html";